const stripeSyncIssues = {
  count_one: '<1>{{ count }}</1> problema sin resolver',
  count_other: '<1>{{ count }}</1> problemas sin resolver',

  actions: 'Acciones',
  count: '<1>{{count}}</1> problema(s) sin resolver',
  createdAt: 'Creado el',
  dealer: 'Distribuidor',
  markAsResolved: 'Marcar como resuelto',
  message: 'Mensaje',
  resolved: 'Resuelto',
  status: 'Estado',
  syncNumber: 'Número de sync',
  syncNumberDescription:
    'Contador incremental para el intento de sincronización en el que se detectó el problema.',
  title: 'Problemas de sincronización de Stripe',
  updatedAt: 'Actualizado el',
  unresolved: 'Sin resolver',
};

export default stripeSyncIssues;
